import { render, staticRenderFns } from "./radio-list.vue?vue&type=template&id=0eb1572a&scoped=true&lang=pug&"
import script from "./radio-list.vue?vue&type=script&lang=coffee&"
export * from "./radio-list.vue?vue&type=script&lang=coffee&"
import style0 from "./radio-list.vue?vue&type=style&index=0&id=0eb1572a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb1572a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormRadioItem: require('/opt/build/repo/library/components/globals/form/radio-item.vue').default})
